import { AccountType } from '@xbcb/shared-types';
import {
  FederatedShipperUser,
  FederatedForwarderUser,
  ForwarderUser,
  OperatorUser,
  ShipperUser,
} from '__generated__/graphql';

export const getUserAccountType = (
  user?:
    | OperatorUser
    | ForwarderUser
    | ShipperUser
    | FederatedShipperUser
    | FederatedForwarderUser,
): AccountType | undefined => {
  return (
    user?.__typename &&
    {
      ShipperUser: AccountType.SHIPPER,
      ForwarderUser: AccountType.FORWARDER,
      OperatorUser: AccountType.OPERATOR,
      FederatedShipperUser: AccountType.SHIPPER,
      FederatedForwarderUser: AccountType.FORWARDER,
    }[user.__typename]
  );
};
